<template>
  <div class="terms-page">
    <SiteHeader/>
    <section class="terms-section">
      <v-container class="pt-16 pb-16">
        <h1 class="terms-title">{{ $t('userSignTermsAndPrivacyPolicy') }}</h1>
        <div class="terms-card">
          <div id="terms-of-use" v-if="termsOfUse" class="terms-prose" v-html="$t('termsOfUseHtml')[termsOfUse.name].replace('DATEUPDATE', new Date(`${termsOfUse.dateUpdate.replace('[UTC]', '')}`).toLocaleString(dateLocale))"></div>
          <v-divider v-if="termsOfUse && privacyPolicy" class="terms-divider"/>
          <div id="privacy-policy" v-if="privacyPolicy" class="terms-prose" v-html="$t('privacyPolicyHtml')[privacyPolicy.name].replace('DATEUPDATE', new Date(`${privacyPolicy.dateUpdate.replace('[UTC]', '')}`).toLocaleString(dateLocale))"></div>
        </div>
        <p class="terms-footnote">Exatamente Solu&ccedil;&otilde;es - CNPJ - 41.228.429/0001-18.</p>
      </v-container>
    </section>
    <SiteFooter/>
  </div>
</template>
<script>
import SiteHeader from "./fragments/SiteHeader.vue";
import SiteFooter from "./fragments/SiteFooter.vue";
import { apiV1TermsOfUse } from '../../service/resources/api-v1-terms-of-use'
import { apiV1PrivacyPolicy } from '../../service/resources/api-v1-privacy-policy'
  export default {
    name: 'TermsAndPrivacyPolicy',
    props: [],
    components: {
      SiteHeader,
      SiteFooter,
    },
    data: () => ({
      termsOfUse: null,
      privacyPolicy: null,
    }),
    watch: {
    },
    mounted: function() {
      this.getTerms()
      this.getPolicy()
    },
    computed: {
      dateLocale: function() {
        return this.$i18n.locale === 'pt-br' ? 'pt-BR' : 'en-US'
      },
    },
    methods: {
      getTerms: function() {
        apiV1TermsOfUse.page({page: 0, size: 1, orderBy: 'id:DESC'}).then(result => {
          if(result.data.content[0])
            this.termsOfUse = result.data.content[0]
        })
      },
      getPolicy: function() {
        apiV1PrivacyPolicy.page({page: 0, size: 1, orderBy: 'id:DESC'}).then(result => {
          if(result.data.content[0])
            this.privacyPolicy = result.data.content[0]
        })
      },
      save: function() {
      }
    },
  }
</script>
<style scoped>
.terms-page {
  font-family: 'Montserrat', sans-serif;
  background: #F7F5EF;
  padding-top: 72px;
}
.terms-section {
  background: #F7F5EF;
}
/* Mesma escala de título usada nas páginas de conteúdo (artigos de SEO):
   2.1rem/900. As páginas com hero de verdade (home, /whats-new) usam uma
   escala maior, à parte, por serem um momento de página diferente. */
.terms-title {
  font-weight: 900;
  font-size: 2.1rem;
  color: #0277BD;
  margin-bottom: 2rem;
}
.terms-card {
  background: #FFFFFF;
  border: 1px solid rgba(16,24,39,0.08);
  border-radius: 1.25rem;
  padding: 2.5rem;
  box-shadow: 0 20px 40px rgba(16,24,39,0.06);
}
.terms-divider {
  margin: 2rem 0;
}
.terms-prose {
  color: #101827;
  font-size: 0.95rem;
  line-height: 1.8;
}
.terms-prose ::v-deep h1,
.terms-prose ::v-deep h2,
.terms-prose ::v-deep h3 {
  color: #101827;
  font-weight: 700;
  margin: 1.5rem 0 0.75rem;
}
.terms-prose ::v-deep p {
  margin-bottom: 0.9rem;
  color: #5B6472;
}
.terms-prose ::v-deep ul,
.terms-prose ::v-deep ol {
  padding-left: 1.2rem;
  margin-bottom: 0.9rem;
  color: #5B6472;
}
.terms-prose ::v-deep li {
  margin-bottom: 0.4rem;
}
.terms-prose ::v-deep a {
  color: #0277BD;
  font-weight: 600;
}
.terms-prose ::v-deep strong {
  color: #101827;
}
.terms-footnote {
  text-align: center;
  color: #5B6472;
  font-size: 0.85rem;
  margin-top: 2rem;
}
</style>
